/**
 * sessionStorage handoff for the "connected account successfully changed" toast (Figma 2118-24858).
 *
 * The signal can't ride React Router `state`: the main AppShell replaces the /network history entry
 * to append `?target_account=<tenant>`, wiping any router state before NetworkLanding's effect reads
 * it. sessionStorage survives that redirect and is cleared once the toast fires, so a refresh never
 * re-shows it.
 */
export const ACCOUNT_CONNECTED_TOAST_KEY = "network:accountConnectedToast";

export type AccountConnectedToastPayload = {
  buyerName: string;
  selectedAccountName: string;
};
